module.exports = __webpack_public_path__ + "img/cart-empty.e4131eba.png";